import React from "react";
import { SvgProps } from ".";

export const UserSvg: React.FC<SvgProps> = ({ fill }) => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    aria-labelledby="Profile-Icon"
  >
    <title id="Profile-Icon">Profile Icon</title>
    <defs>
      <circle id="path-1" cx="15" cy="15" r="15" />
    </defs>
    <g
      id="Profile-Icon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      data-testid="UserSvg"
    >
      <g id="2nd-YR--Welcome-*" transform="translate(-260.000000, -24.000000)">
        <g id="Profile-Icon" transform="translate(261.000000, 25.000000)">
          <g id="z.-Icons/Slate/User">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <use id="Mask" fill="#FFFFFF" xlinkHref="#path-1" />
            <g id="Group" mask="url(#mask-2)">
              <g transform="translate(0.000000, 3.000000)" id="Group">
                <rect id="Rectangle" x="0" y="0" width="30" height="30" />
                <circle
                  id="Oval"
                  stroke={fill || "#1853A3"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  cx="15"
                  cy="11.25"
                  r="7.5"
                />
                <path
                  d="M3.63152344,25.3114031 C5.97737942,21.2509695 10.3107658,18.7499999 15.0001327,18.7499999 C19.6894996,18.7499999 24.0228344,21.2511555 26.3686066,25.3116375"
                  id="Path"
                  stroke={fill || "#1853A3"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
          <circle
            id="Oval"
            stroke={fill || "#1853A3"}
            strokeWidth="2"
            cx="15"
            cy="15"
            r="15"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default {};
